package com.evoapps.evoshift.ui.theme

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.window
import org.w3c.dom.events.Event

/** The browser's `prefers-reduced-motion: reduce`, followed live. */
@Composable
actual fun prefersReducedMotion(): Boolean {
    val query = remember { window.matchMedia("(prefers-reduced-motion: reduce)") }
    var reduced by remember { mutableStateOf(query.matches) }
    DisposableEffect(query) {
        val listener: (Event) -> Unit = { reduced = query.matches }
        query.addEventListener("change", listener)
        onDispose { query.removeEventListener("change", listener) }
    }
    return reduced
}

/** SH-198: Material's shared axis X, as Android. */
actual val platformStackMotion: StackMotion = StackMotion.SHARED_AXIS
